import api from "./api";

const attendanceService = {
  getAttendance: (params) => api.get("/attendance", { params }),

  getAttendanceById: (id) => api.get(`/attendance/${id}`),

  startSession: (sessionData) =>
    api.post("/attendance/session/start", sessionData),

  endSession: (sessionId) => api.post(`/attendance/session/${sessionId}/end`),

  getActiveSession: (classId) =>
    api.get(`/attendance/session/active/${classId}`),

  markAttendance: (attendanceData) =>
    api.post("/attendance/mark", attendanceData),

  markBulkAttendance: (attendanceData) =>
    api.post("/attendance/mark-bulk", attendanceData),

  updateAttendance: (id, attendanceData) =>
    api.put(`/attendance/${id}`, attendanceData),

  getAttendanceReport: (params) => api.get("/attendance/report", { params }),

  getStudentAttendance: (studentId, params) =>
    api.get(`/attendance/student/${studentId}`, { params }),

  // Per-lecture attended/missed breakdown for a student over a date range.
  // params: { startDate?, endDate?, subjectId? } (YYYY-MM-DD).
  // Response data: { summary, subjectWise, details:[{ lectureDate, subject,
  // status, attended, method, markedAt, ... }], range }.
  getStudentLectureBreakdown: (studentId, params) =>
    api.get(`/attendance/student/${studentId}/lectures`, { params }),

  getClassAttendance: (classId, params) =>
    api.get(`/attendance/class/${classId}`, { params }),

  getStatistics: (params) => api.get("/attendance/statistics", { params }),

  downloadReport: (params) =>
    api.get("/attendance/report/download", {
      params,
      responseType: "blob",
    }),

  getAttendanceByDate: (date, classId) =>
    api.get("/attendance/by-date", { params: { date, classId } }),

  // Smart attendance (QR / OTP / Manual)
  createQrSession: (payload) => api.post("/attendance/session/qr/create", payload),

  createOtpSession: (payload) => api.post("/attendance/session/otp/create", payload),

  rotateSession: (sessionId) => api.post(`/attendance/session/${sessionId}/rotate`),

  startManualSession: (payload) => api.post("/attendance/session/manual/start", payload),

  getSession: (sessionId) => api.get(`/attendance/session/${sessionId}`),

  getRoster: (classId, params) =>
    api.get(`/attendance/class/${classId}/roster`, { params }),

  validateLocation: (payload) => api.post("/attendance/location/validate", payload),
  getManualUploadSessions: (params) => api.get("/attendance/manual-upload/sessions", { params }),
  downloadManualUploadSampleCsv: () => api.get("/attendance/manual-upload/sample-csv", { responseType: "blob" }),
  uploadManualAttendanceCsv: (formData) => api.post("/attendance/manual-upload/upload", formData),
  getAttendanceUploadLogs: (params) => api.get("/attendance/upload-logs", { params }),
  getAttendanceUploadLogById: (id) => api.get(`/attendance/upload-logs/${id}`),
  downloadAttendanceUploadLogErrors: (id) =>
    api.get(`/attendance/upload-logs/${id}/error-report`, { responseType: "blob" }),
};

export default attendanceService;
